<template>
  <v-app :class="getColourTheme">
    <dui-snackbar
      v-model="snackOpen"
      :color="snackColor"
      :message="snackMessage"
      :classSnack="snackClass"
      :styleSnack="snackStyle"
    />
    <ErrorDialog />
    <v-main>
      <nuxt />
    </v-main>
  </v-app>
</template>

<script>
import mixinSnackbar from "@/mixins/Snackbar/mixinSnackbar";

import mixinComputed from "~/layouts/mixins/mixinComputed";
import mixinMethods from "~/layouts/mixins/mixinMethods";
import mixinWindowResize from "~/layouts/mixins/mixinWindowResize";

import ErrorDialog from "~/components/shared/ErrorDialog/ErrorDialog.vue";

export default {
  name: "LayoutClean",

  components: {
    ErrorDialog,
  },

  mixins: [mixinWindowResize, mixinSnackbar, mixinComputed, mixinMethods],
  created() {
    this.setTheme();
    localStorage.removeItem("exam");
  },
};
</script>

<style lang="scss" scoped>
// login page full height
::v-deep > .v-content__wrap,
::v-deep > .v-main__wrap {
  > div {
    height: 100%;
  }
}
</style>
